export default __webpack_public_path__ + "static/media/Credit_Cards.443a166e.pdf";